import {FiClock} from "react-icons/fi";

import {TooltipIconRA} from "@/components/overlay/TooltipIconRA.tsx";
import {ScheduleState} from "@/lib/types/checks.ts";

export interface ScheduleIconCellProps {
  scheduleState: ScheduleState;
}

export const ScheduleIconCell = ({scheduleState}: ScheduleIconCellProps) =>
  scheduleState === ScheduleState.SCHEDULED && (
    <TooltipIconRA
      icon={FiClock}
      iconProps={{size: "core", removeDivDimensions: true}}
      title="This Contact has specified on-call hours."
      className="pulse-color-gray-700"
    />
  );
